export const WindChinese: { [key: string]: string } = {
  east: "東",
  south: "南",
  west: "西",
  north: "北",
};
